import { useEffect, useRef } from 'react'
import queryString from 'query-string'

import { useSetState } from '@domain-group/react-hooks'

import { baseURLWithoutVersion } from '@functions/api'
import callApi from '@functions/callApi'

const defaultState = {
  csrfToken: '',
}

type SetState = (state: Partial<typeof defaultState>) => void

const setCsrfToken = async (setState: SetState, signal: AbortSignal) => {
  const config = { baseURL: baseURLWithoutVersion, withCredentials: true, signal }

  const result = await callApi<{ csrf_token: string }>('csrf_token', {}, config)
  if (result.success) setState({ csrfToken: result?.data?.csrf_token ?? '' })

  return result
}

type Options = { queryParams: { [key: string]: any } }

function useOAuthIntegration(authProviderKey: string, options?: Options) {
  const { queryParams } = options || {}

  const [state, setState] = useSetState(defaultState)
  const { csrfToken } = state

  const formRef = useRef()

  useEffect(() => {

    const controller = new AbortController()
    setCsrfToken(setState, controller.signal)

    return () => controller.abort()
  }, [])

  const baseHref = `${baseURLWithoutVersion}/users/auth/${authProviderKey}`

  return {
    callbacks: {
      // @ts-expect-error TS18048
      onClick: () => formRef.current.submit(),
    },
    csrfToken,
    href: queryParams ? `${baseHref}?${queryString.stringify(queryParams)}` : baseHref,
    formRef,
  }
}

export type UseOAuthIntegrationPayload = ReturnType<typeof useOAuthIntegration>

export default useOAuthIntegration
